import React from 'react';
import Container from '../ui/Container';
import PageHeader from '../ui/PageHeader';
import Spinner from '../ui/Spinner';
import EmptyState from '../ui/EmptyState';
import { useTranslation } from '../context/TranslationContext';
import { useModules } from '../modules/useModules';
import styles from './Dashboard.module.css';

export default function Dashboard() {
  const { t } = useTranslation();
  const { modules, loading } = useModules();

  const widgets = modules
    .flatMap((m) =>
      (m.dashboardWidgets || []).map((w) => ({
        ...w,
        moduleId: m.id,
        moduleOrder: m.order,
      }))
    )
    .sort(
      (a, b) =>
        a.moduleOrder - b.moduleOrder || (a.order || 0) - (b.order || 0)
    );

  return (
    <Container>
      <PageHeader title={t('dashboard')} />

      {loading && widgets.length === 0 && (
        <div className={styles.centered}>
          <Spinner size="lg" label={t('loading')} />
        </div>
      )}

      {!loading && widgets.length === 0 && (
        <EmptyState
          icon="fa-th-large"
          title={t('dashboardEmptyTitle')}
          description={t('dashboardEmptyDescription')}
        />
      )}

      {widgets.length > 0 && (
        <div className={styles.grid}>
          {widgets.map((w) => {
            const Widget = w.component;
            return (
              <div key={`${w.moduleId}:${w.key}`} className={styles.cell}>
                <Widget />
              </div>
            );
          })}
        </div>
      )}
    </Container>
  );
}
